import * as React from 'react';
import Svg, {
  SvgProps, G, Path, Defs, ClipPath,
} from 'react-native-svg';

const MeterIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
    style={{ transform: [{ scale: 0.7 }] }}
  >
    <G
      stroke={props.stroke ?? '#000'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <Path d="M15.53 2.47 2.47 15.53a.75.75 0 0 0 0 1.06l4.94 4.94a.75.75 0 0 0 1.06 0L21.53 8.47a.75.75 0 0 0 0-1.061l-4.939-4.94a.75.75 0 0 0-1.06 0ZM12 6l3 3M9 9l3 3M6 12l3 3" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default MeterIcon;
